import { LmText } from '@mes-ui/lemma';
import { Box, Stack, useMediaQuery } from '@mui/material';
import { WidgetsData } from 'api/types/widgets';
import { commonTheme } from 'portfolio3/styles/theme';

import { WIDGET_BLOCKS } from '../consts';

type CommonContentProps = {
  widgetData: WidgetsData[number];
};

const CommonContent = ({ widgetData }: CommonContentProps) => {
  const isMobile = useMediaQuery(commonTheme.breakpoints.down('commonSm'));
  const CONTENT_HEIGHT = isMobile ? 66 : 80;
  const widgetBlockData = WIDGET_BLOCKS[widgetData.blockName];

  const Icon = widgetBlockData.icon;

  return (
    <Stack spacing={1.5} direction="row">
      <Box
        sx={{
          width: CONTENT_HEIGHT,
          height: CONTENT_HEIGHT,
          backgroundColor: widgetBlockData.iconBgColor,
          borderRadius: '22px',
          position: 'relative',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon
          style={{
            width: 57.14,
            height: 57.14,
          }}
          fill={widgetBlockData.iconColor}
        />
      </Box>
      <Stack direction="column" spacing={0.5}>
        <LmText variant="lg" weight="medium">
          В этом разделе есть обновления
        </LmText>
      </Stack>
    </Stack>
  );
};

export default CommonContent;
